<template>
  <el-dialog class="dialog-simple" :visible.sync="visible" :title="dialogTitle" width="580px" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" :size="size" ref="dataForm" label-position='right' label-width="60px" v-loading="dialogLoading">
      <el-form-item prop="remark" label="名称">
        <el-input v-model.trim="dataForm.remark" placeholder="" clearable></el-input>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" slot="footer" style="text-align: right">
      <el-button class="submit" :size="size" type="primary" @click="submitHandle()" :loading="dialogLoading">确 定</el-button>
      <el-button class="close" :size="size" @click="visible = false">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  name: 'addOrUpdate',
  props: {
    dialogTitle: {
      type: String,
      default: '编辑'
    },
    isRedispatch: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      size: 'small',
      dialogLoading: false,
      visible: false,
      staff: [],
      dataForm: {
        orderId: 0,
        mainExecutor: '',
        teamMembers: [],
        remark: ''
      },
    }
  },
  computed: {
    dataRule () {
      return {
      }
    }
  },
  methods: {
    init (row) {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
      })
    },
    handleGetInfo () {
    },
    submitHandle:debounce (function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.dialogLoading = true
        this.$api.electricOperations.setElectricOperationsWorkOrderExecutor(
          this.dataForm.orderId,
          this.dataForm.mainExecutor, 
          this.dataForm.teamMembers
        ).then((res) => {
          if (res.success) {
            this.visible = false
            this.$message.success('操作成功')
            this.$emit('handleQuery')
          }
          this.dialogLoading = false
        })
      })
    }, 1000, { 'leading': true, 'trailing': false } )
  }
}
</script>

<style lang="scss" scoped>
</style>
